import { observer } from 'mobx-react';
import * as React from 'react';
import { ExpiredProgram } from '../../ProgramStore/Types';
import { Link } from '../../Resource/Types';
import {
  ProgramCard,
  ProgramCardBody,
  ProgramCardFooter,
  ProgramCardHeader,
  ProgramCardTitle,
} from '../Dashboard/ProgramCard';
import ProgramCardTeam from '../Dashboard/ProgramCard/ProgramCardTeam';
import ProgramOutcomePanel from '../Dashboard/ProgramCard/ProgramOutcomePanel';

interface Props {
  programDetail: ExpiredProgram;
  links: ReadonlyArray<Link>;
}

// Access to a past program has ended, so the card has no action button.
const ExpiredProgramOverview: React.FC<Props> = ({ programDetail, links }) => (
  <ProgramCard data-test-expired-program={true}>
    <ProgramCardHeader links={links} programInstanceKind={programDetail.programInstanceKind} />
    <ProgramCardTitle title={programDetail.title} />
    <ProgramCardBody>
      <ProgramOutcomePanel programDetail={programDetail} />
    </ProgramCardBody>
    <ProgramCardFooter>
      <ProgramCardTeam programId={programDetail.id} />
    </ProgramCardFooter>
  </ProgramCard>
);

export default observer(ExpiredProgramOverview);
